const types = {
    SET_USERS_LIST: '[USERS MOBILE] SET USERS LIST',
    SET_USER_BY_ID: '[USERS MOBILE] SET USER BY ID',
    SET_REZYME: '[USERS MOBILE] SET REZYME',
    SET_LAST_OPERATION: '[USERS MOBILE] SET LAST OPERATION',
    SET_REPLENISHMENT_USER: '[USERS MOBILE] SET REPLENISHMENT USER',
    SET_WITHDRAWALS_USER: '[USERS MOBILE] SET WITHDRAWALS USER',
    SET_BONUSES_HISTORY: '[USERS MOBILE] SET BONUSES HISTORY',
    SET_HISTORY_LIST: '[USERS MOBILE] SET HISTORY LIST',
    SET_JACKPOT: '[USERS MOBILE] SET JACKPOT'
}

export {
    types
}